/* Dansk katalog for locale-assets-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  "supplierPay.correct": "Ret leverand\u00f8rbetaling",
  "purchaseFlow.subtitle": "K\u00f8b, leverand\u00f8rfakturaer og betalinger",
  "purchaseFlow.type": "Type",
  "supplierPay.settlement": "Betaling",

  "asset.impairmentCancelled": "Annulleret nedskrivning",
  "asset.impairmentCorrectionBlocked": "Select an active impairment with one attributable asset and enter a reason. Correct subsequent asset postings first. Sold and imported assets require review.",
  "asset.correctionEntriesRequired": "The correction requires attributable entries in the same open year, no later than the correction date.",
  "asset.alreadyCancelled": "This acquisition has already been cancelled.",
  "asset.cancelCurrentDate": "Purchase cancellation uses the current accounting reversal date.",
  "asset.cancelWholePurchase": "Select an unsold whole-purchase asset. Mixed purchases require a document-level correction.",
  "asset.cancelSameYear": "Document a correction in the same open acquisition year.",

  'err.purchase.invoiceNumberRequired': 'Indtast leverandørens fakturanummer før bogføring.',
  'err.supplierPayment.reverseUseFirst': 'Tilbagefør tilbagebetaling og brug af tilgodehavendet, før betalingen tilbageføres.',
  'supplierPay.description': 'Betaling af leverandørfaktura {number}',
  'supplierPay.total': 'Fakturabeløb',
  'supplierPay.paid': 'Betalt / udlignet',
  'supplierPay.remaining': 'Resterende',
  'supplierPay.available': 'Tilgode hos leverandøren',
  'supplierPay.register': 'Registrer betaling',
  'supplierPay.link': 'Tilknyt eksisterende postering',
  'supplierPay.history': 'Betalingshistorik',
  'supplierPay.selectInvoice': 'Faktura, der betales',
  'supplierPay.noInvoice': 'Ingen faktura valgt',
  'supplierPay.overpayment': 'Det overskydende beløb på {amount} står til gode hos leverandøren.',
  'supplierPay.open': 'Åbn',
  'supplierPay.openTotal': 'Ubetalte fakturaer',
  'err.asset.reverseSaleBeforeAcquisition': 'Fortryd salget, før du ændrer eller annullerer anskaffelsen.',
  'asset.tabDrafts': 'Kladder ({n})',
  'asset.bookValueAtSale': 'Regnskabsmæssig værdi på salgsdatoen',
  'asset.taxDepreciation': 'Skattemæssig afskrivning',
  'asset.bookTaxExplanation': 'Den regnskabsmæssige værdi følger aktivets afskrivningsplan. Skatteværdien beregnes separat efter saldogruppen. Skattetallene gælder hele gruppen, når flere aktiver indgår.',
  'asset.automationActivate': 'Aktivér og bogfør',
  'asset.automationCatchUp': 'Kontrollér og bogfør udestående',
  'asset.automationPause': 'Sæt automatik på pause',
  'asset.automationConfirmEnable': 'Bekræft og bogfør',
  'asset.automationConfirmAmount': 'Du godkender afskrivningsplanerne og bogfører {amount} for afsluttede måneder til og med {date}. Derefter bogføres nye afsluttede måneder automatisk.',
  'asset.automationPauseExplanation': 'Fremtidig automatisk bogføring sættes på pause. Allerede bogførte afskrivninger bevares. Afskrivningsbehovet forsvinder ikke; udestående beløb skal stadig bogføres.',
  'asset.automationEnabledSaved': 'Automatik godkendt og afsluttede måneder bogført.',
  'asset.automationPausedSaved': 'Automatik sat på pause. Bogførte afskrivninger er bevaret.',
  'asset.automationSaveFailed': 'Ændringen kunne ikke bekræftes. Kontrollér status, før du prøver igen.',
  'asset.automationPostingNotConfirmed': 'Bogføringen er ikke bekræftet. Kontrollér udestående beløb og bilag. Gå ikke ud fra, at afskrivningerne er bogført, bare fordi automatik er aktiveret.',
  'asset.automationBasisChanged': 'Grundlaget er ændret. Luk dialogen, og kontrollér beløbene igen.',
  'asset.automationRequestUncertain': 'Serveren svarede ikke i tide. Bogføringen kan være gennemført. Opdater regnskabet, og kontrollér bilagene, før du prøver igen.',
  'asset.automationStatusAwaiting': 'Automatik er aktiveret. Der er endnu ikke bogført afskrivninger.',
  'asset.postingReviewRequired': 'Skal afstemmes',
  'asset.projectedYearEndValue': 'Beregnet værdi ved årets udgang (plan)',
  'asset.usefulLifeSuggestionHelp': 'Levetiden er et redigerbart forslag baseret på gruppen. Tilpas til forventet brug; dette er ikke en skatteregel.',
  'asset.advancedOptions': 'Avanceret',
  'asset.advancedOptionsHelp': 'Tilpas levetid, restværdi eller ekstra værdifald efter behov. Standardværdierne er allerede udfyldt.',
  'asset.editAdjustments': 'Tilpas',
  'asset.hideAdjustments': 'Skjul',
  'asset.automaticPlanSummary': 'Levetid: {years} år. Restværdi: {residual}.',
  'asset.noExtraImpairmentDefault': 'Ingen ekstra nedskrivning som standard.',
  'asset.optionalDocumentation': 'Dokumentation / begrundelse (valgfrit)',
  'asset.title': 'Aktiver',
  'asset.subtitle': 'Udstyr og værdier, som virksomheden ejer over tid',
  'asset.new': 'Nyt aktiv',
  'asset.info': 'Info',
  'asset.accounting': 'Regnskab',
  'asset.moreActions': 'Flere handlinger',
  'asset.automationStatusTitle': 'Automatisk månedsbogføring',
  'asset.automationStatusActive': 'Aktiv. Seneste bogføring til og med {date}.',
  'asset.automationStatusDefault': 'Slået til som standard. Nye aktiver bogføres automatisk hver måned efter registrering.',
  'asset.taxAutomaticTitle': 'Skattemæssig afskrivning beregnes automatisk',
  'asset.taxAutomaticHelp': 'Plumme bruger de almindelige skatteregler og foreslår beløbene for {year}. Du behøver normalt ikke gøre noget her.',
  'asset.taxAutomaticDepreciation': 'Beregnet afskrivning',
  'asset.taxAutomaticIncome': 'Beregnet indtægtsførsel',
  'asset.taxAutomaticDeduction': 'Beregnet tabsfradrag',
  'asset.taxAdvancedChoices': 'Avancerede valg',
  'asset.taxAdvancedHelp': 'Brug kun dette, når du vil afvige fra Plummes forslag eller registrere en primo gevinst- og tabskonto ved systemskifte.',
  'asset.changeTaxElection': 'Ændr skattemæssigt valg',
  'asset.taxElectionCurrentDefault': 'Plummes automatiske forslag for den valgte saldo er {amount}.',
  'asset.taxElectionOverrideRequired': 'Angiv et beløb, der skal afvige fra det automatiske forslag.',
  'asset.taxElectionReasonRequired': 'Skriv, hvorfor du tilsidesætter det automatiske forslag.',
  'asset.automationStatusOff': 'Fra. Aktivér én gang for at bogføre afsluttede måneder automatisk.',
  'asset.automationStatusReview': 'Sat på pause. Kontrollér planerne, og godkend automatik igen.',
  'asset.automationApprovalNote': 'Godkendt automatisk månedlig bogføring af regnskabsmæssige afskrivninger.',
  'asset.automationApprovalFailed': 'Aktivet blev registreret, men automatisk månedsbogføring kunne ikke aktiveres. Kontrollér status på aktivsiden.',
  'asset.autoPostingActive': 'Automatisk månedsbogføring er standard',
  'asset.monthlyDepreciationPreview': 'Den regnskabsmæssige afskrivning bliver ca. {amount} pr. måned og bogføres automatisk efter registrering.',
  'asset.monthlyDepreciationPreviewOff': 'Automatisk månedsbogføring er deaktiveret under Indstillinger – Regnskab.',
  'asset.manageInSettings': 'Administrer i indstillinger',
  'asset.special.financing': 'Lån og finansiering',
  'asset.special.tradeIn': 'Byttehandel',
  'asset.special.partialSale': 'Delsalg',
  'asset.special.property': 'Fast ejendom',
  'asset.specialCasesHelp': 'Praktisk vejledning til situationer, der kræver særskilt dokumentation eller opdeling.',
  'asset.automationStopNote': 'Automatisk månedlig bogføring stoppet af brugeren.',
  'asset.unpostedDepreciation': 'Mangler at blive bogført: {amount} til og med {date}.',
  'asset.importedHistory': 'Importeret historik',
  'asset.importedHistoryHelp': 'Historisk aktiv importeret fra et andet regnskabssystem. Værdier og afskrivninger vises fra importsporet og bogføres ikke igen i Plumme.',
  'asset.edit': 'Rediger aktiv',
  'asset.registerSold': 'Registrer som solgt',
  'asset.moreOptions': 'Flere valg',
  'asset.reclassifyPurchase': 'Lav om til almindeligt køb',
  'asset.reclassifyTitle': 'Lav om til almindeligt køb',
  "asset.acquisitionLockedTitle": "Hvorfor er handlingerne spærret?",
  "asset.acquisitionLockedSold": "Aktivet er solgt. Tilbagefør salget før købet korrigeres.",
  "asset.acquisitionLockedReview": "Afstem bogføringen før købet korrigeres.",
  "asset.acquisitionLockedDepreciation": "Aktivet har bogførte afskrivninger. Købet og aktivet kan ikke ændres eller fjernes direkte. Brug rettelsen nedenfor, hvis købet skulle være udgiftsført. Hvis selve købet er forkert, kræves sporbare modposteringer af afskrivninger og køb.",
  "asset.correctCapitalization": "Korriger fejlagtig aktivering",
  "asset.correctCapitalizationBody": "Brug kun dette, når købet er korrekt, men skulle være udgiftsført. Afskrivningerne tilbageføres, og anskaffelsesprisen flyttes til valgt omkostningskonto i én gemning. Originalbilag, moms og betalinger bevares. Vælg en dato efter sidste afskrivning i samme åbne år. Gruppeafskrivninger og nedskrivninger kræver særskilt gennemgang.",
  'asset.reclassifyBody': 'Brug dette, når købet er korrekt, men ikke skulle have været registreret som aktiv. Bilaget bevares, og posteringen flyttes fra aktivkontoen til den valgte omkostningskonto.',
  'asset.expenseAccount': 'Omkostningskonto',
  'asset.correctionReason': 'Årsag',
  'asset.correctionReasonPh': 'F.eks. under beløbsgrænsen / forkert klassificering',
  'asset.reclassifiedToast': 'Købet er lavet om til et almindeligt køb.',
  'asset.reclassifyError': 'Kunne ikke lave aktivet om til et almindeligt køb.',
  'asset.annulPurchase': 'Annuller købsbilag',
  'asset.annulTitle': 'Annuller købsbilag',
  'asset.annulBody': 'Brug dette, når hele købsbilaget er forkert eller dobbeltbogført. Bilaget slettes ikke fra historikken, men posteringen fjernes fra rapporter og saldobalance.',
  'asset.annulLocksTitle': 'Kan være låst af moms, bank eller årsafslutning',
  'asset.annulLocksBody': 'Hvis perioden er indberettet, bankafstemt eller årsafsluttet, skal den genåbnes eller korrigeres, før bilaget kan annulleres.',
  'asset.annulReasonPh': 'F.eks. dobbeltbogført bilag / forkert upload',
  'asset.annulledToast': 'Købsbilaget er annulleret.',
  'asset.annulError': 'Kunne ikke annullere købsbilaget.',
  'asset.markMistaken': 'Markér aktiv som fejlregistreret',
  'asset.saleDate': 'Salgsdato',
  'asset.bookValueShort': 'Regnskabsværdi',
  'asset.saleAmountExVat': 'Salgsbeløb ekskl. moms',
  'asset.vat': 'Moms',
  'asset.howRegisterSale': 'Hvordan vil du registrere salget?',
  'asset.continueTitle': 'Fortsæt?',
  'asset.continue': 'Fortsæt',
  'asset.undoDeleteTitle': 'Fortryd sletning?',
  'asset.undoDelete': 'Fortryd sletning',
  'asset.undoSaleTitle': 'Fortryd salg?',
  'asset.undoSale': 'Fortryd salg',
  'asset.saveDraft': 'Gem kladde',
  'asset.name': 'Navn på driftsmiddel',
  'asset.namePh': 'F.eks. MacBook Pro 16"',
  'asset.depreciationNote': 'Dette køb registreres som driftsmiddel og afskrives ved årsafslutningen.',
  'asset.supplierPurchase': 'Leverandørkøb',
  'asset.supplier': 'Leverandør',
  'asset.invoiceNumber': 'Fakturanummer',
  'asset.invoiceNumberPh': 'F.eks. 100245',
  'asset.lines': 'Linjer',
  'asset.linePh': 'F.eks. maskine, pc eller værktøj',
  'asset.account': 'Driftsmiddelkonto',
  'asset.vatRate': 'Momssats',
  'asset.addLine': 'Tilføj linje',
  'asset.paidBy': 'Betalt af',
  'asset.payOperating': 'Driftskonto - 1920',
  'asset.payCash': 'Kontant - 1900',
  'asset.payPrivate': 'Privat - 2060',
  'asset.payLoan': 'Betalt ved låneoptagelse - 2250',
  'asset.splitPayment': 'Del betalingen',
  'asset.partPayments': 'Delbetalinger',
  'asset.fullPayment': 'Fuld betaling',
  'asset.addPartPayment': 'Tilføj delbetaling',
  'asset.uploadFile': 'Upload fil',
  'asset.dropFiles': 'Træk og slip filer her, eller vælg fra computeren.',
  'asset.removeAttachment': 'Fjern vedhæftning',
  'asset.sold': 'Solgt',
  'asset.depreciated': 'Afskrevet',
  'asset.active': 'Aktiv',
  'asset.viewsTitle': 'Visninger',
  'asset.viewsHelp': 'Filtrér listen: »Aktive« er aktiver med resterende bogført værdi, som stadig afskrives, »Afskrevne« er fuldt nedskrevet til 0, »Solgte« er afhændet, og »Alle« viser alt.',
  'asset.noneInView': 'Ingen aktiver i denne visning endnu',
  'asset.fromPurchase': 'Registrér fra et køb',
  'asset.group': 'Gruppe',
  'asset.groupHelp': 'Saldogruppen afgør afskrivningssatsen — hvor stor en andel der kan afskrives skattemæssigt hvert år. F.eks. har gruppe C (varebiler) og gruppe D (maskiner, inventar) forskellige satser fastsat af Skatteetaten.',
  'asset.depreciatedHelp': 'Summen, der er udgiftsført indtil nu — altså hvor meget af kostprisen der allerede er afskrevet gennem årene. Kostpris minus afskrevet giver bogført værdi.',
  'asset.bookValue': 'Bogført værdi',
  'asset.bookValueHelp': 'Aktivets resterende værdi i regnskabet nu — kostpris minus det, der er afskrevet. Det er beløbet, der står tilbage at afskrive i de kommende år.',
  'asset.declining': 'Saldoafskrivning og skemaer',
  'asset.decliningHelp': 'Saldoafskrivning er den mest almindelige afskrivningsmetode: hvert år afskrives en fast procentdel af den resterende saldo pr. gruppe. Tabellen viser grundlaget pr. saldogruppe. RF-1084 og RF-1217 er Skatteetatens skemaer for afskrivning og midlertidige forskelle — Plumme udfylder dem ud fra tallene her.',
  'asset.opening': 'Primo',
  'asset.additions': 'Nyanskaffelser',
  'asset.disposals': 'Salg',
  'asset.movements': 'Bevægelser',
  'asset.depreciation': 'Afskrivning',
  'asset.closing': 'Ultimosaldo',
  'asset.groupDFallback': 'Saldogruppe d - personbiler, maskiner og inventar',
  'asset.attachmentFallback': 'Vedhæftning',
  'asset.pageTitleHelp': 'Aktiver (driftsmidler) er større ting, som virksomheden ejer og bruger over flere år — pc, køretøj, maskiner, inventar. De udgiftsføres ikke med det samme, men afskrives: omkostningen fordeles lidt hvert år over levetiden. Her holder Plumme styr på afskrivning og skemaværdier for dig.',
  'asset.pageAddHelp': 'Registrér et nyt aktiv, når et driftsmiddel har en kostpris på mindst 30 000 kr og en forventet brugstid på mindst tre år. Grænsen gælder ikke fakturabeløbet alene.',
  'asset.emptyText': 'Aktiver er ting, som virksomheden ejer og bruger over flere år — som en pc, et køretøj eller værktøj. De afskrives lidt hvert år. Registrér et aktiv fra et køb, så holder vi styr på afskrivning og skemaværdier for dig.',
  'asset.tabActive': 'Aktive ({n})',
  'asset.tabDepreciated': 'Afskrevne ({n})',
  'asset.tabSold': 'Solgte ({n})',
  'asset.tabAll': 'Alle ({n})',
  'asset.colAsset': 'Aktiv',
  'asset.soldOnLabel': 'solgt {date}',
  'asset.acquiredInline': 'Anskaffet {date}',
  'asset.groupRateInline': 'Gruppe {group} · {rate} %',
  'asset.colAcquired': 'Anskaffet',
  'asset.colCost': 'Kostpris',
  'asset.costInline': 'Kostpris {amount}',
  'asset.colStatus': 'Status',
  'asset.decliningDescription': 'Grundlag for saldoafskrivning pr. gruppe. RF-1084 / RF-1217 vises som skemareferencer for norsk skattelogik.',
  'asset.depreciationInline': 'Afskrivning −{amount}',
  'asset.atYearEnd': 'Ved udgangen af {year}',
  'asset.accountingValue': 'Regnskabsmæssig værdi',
  'asset.taxValue': 'Skattemæssig værdi',
  'asset.temporaryDifference': 'Midlertidig forskel',
  'asset.noCustomer': 'Uden kunde',
  'asset.fallbackNoun': 'aktiv',
  'asset.saleLineDescription': 'Salg af {name}',
  'asset.deletedStatus': 'Slettet',
  'asset.updateFailed': 'Kunne ikke opdatere aktivet.',
  'asset.transitionSaved': 'Overgangsværdier og vurdering er gemt.',
  'asset.transitionSaveFailed': 'Kunne ikke gemme overgangsværdierne.',
  'asset.soldPendingOther': 'Gennemfør Andet salg for at registrere aktivet som solgt',
  'asset.soldPendingInvoice': 'Opret fakturaen for at registrere aktivet som solgt',
  'asset.registeredSold': 'Aktiv registreret som solgt',
  'asset.detailTitle': 'Aktiv: {name}',
  'asset.tabInfo': 'Information',
  'asset.tabDepreciationChanges': 'Afskrivning / ændringer',
  'asset.tabForms': 'Skemaer',
  'asset.purchaseDate': 'Købsdato',
  'asset.purchasePrice': 'Købspris',
  'asset.assetAccountLabel': 'Aktivkonto',
  'asset.missingValue': 'Mangler',
  'asset.usefulLifeLabel': 'Økonomisk levetid',
  'asset.yearsCount': '{n} år',
  'asset.taxDepreciationRateLabel': 'Skattemæssig afskrivningssats',
  'asset.impairmentAssessmentYear': 'Værdiforringelsestest {year}',
  'asset.noIndicators': 'Ingen indikatorer',
  'asset.impairedAmount': 'Nedskrevet {amount}',
  'asset.transitionHeading': 'Overgang til Plumme',
  'asset.transitionBody': 'Historiske bogførte værdier bevares. Registrér en separat skattemæssig indgangsværdi og en faglig plan for den videre årsafslutning.',
  'asset.registerTransitionValues': 'Registrér overgangsværdier',
  'asset.colYear': 'År',
  'asset.colType': 'Type',
  'asset.colDescription': 'Beskrivelse',
  'asset.colAccountingChange': 'Regnskabsmæssig ændring',
  'asset.colNewValue': 'Ny værdi',
  'asset.sellTitle': 'Registrér aktiv som solgt: {name}',
  'asset.sellNoInvoice': 'Registrér salg uden faktura',
  'asset.createInvoiceBtn': 'Opret faktura',
  'asset.markSoldBtn': 'Markér som solgt',
  'asset.gainOnSale': 'Gevinst ved salg',
  'asset.lossOnSale': 'Tab ved salg',
  'asset.sellMethodMarkDesc': 'Bruges, når salgsindtægten allerede er bogført.',
  'asset.sellMethodOtherDesc': 'Åbner Andet salg med aktivet forudfyldt.',
  'asset.sellMethodInvoiceDesc': 'Åbner en ny fakturakladde med aktivet som linje.',
  'asset.sellHelperPrefix': 'Salget reducerer afskrivningssaldoen i gruppe {group}.',
  'asset.sellHelperMarkSuffix': 'Vælg kun dette, når indtægten allerede er bogført.',
  'asset.sellHelperOtherSuffix': 'Vi sender dig videre, så du kan bogføre selve salgsindtægten.',
  'asset.continueDeleteBody': 'Brug kun dette, hvis aktivet blev registreret ved en fejl og ikke skal afskrives. Udførte årsafslutnings-/afskrivningsposter bør tilbageføres, før aktivet markeres som slettet.',
  'asset.markedDeleted': 'Aktiv markeret som slettet',
  'asset.restoreDeleteBody': 'Dette gør aktivet aktivt igen og medtager det i saldogruppe, skattemæssig værdi og afskrivningsgrundlag. Hvis du har kørt årsafslutning eller bogført afskrivninger, mens aktivet var slettet, bør disse kontrolleres og eventuelt tilbageføres, før du fortsætter.',
  'asset.deleteUndone': 'Sletning fortrudt',
  'asset.restoreSaleBody': 'Dette gør aktivet aktivt igen og fjerner salget fra saldogruppen og afskrivningsgrundlaget. Det sletter eller krediterer ikke en faktura eller andet salg, der allerede er registreret i salgsflowet. Kontrollér årsafslutning og afskrivningsposter, hvis de blev oprettet, efter at salget blev registreret.',
  'asset.saleUndone': 'Salg fortrudt',
  'asset.transitionTitle': 'Overgangsværdier: {name}',
  'asset.saveAssessment': 'Gem vurdering',
  'asset.savingEllipsis': 'Gemmer…',
  'asset.planStartLabel': 'Planstart i Plumme',
  'asset.remainingUsefulLifeYearsLabel': 'Resterende brugstid (år)',
  'asset.taxOpeningValueYear': 'Skattemæssig primoværdi {year}',
  'asset.impairmentToBeRecordedShort': 'Nedskrivning registreres',
  'asset.impairmentAmountLabel': 'Nedskrivningsbeløb',
  'asset.documentationLabel': 'Dokumentation / begrundelse',
  'asset.importedHistoryUnchanged': 'Importeret historik ændres ikke. Planen starter med den bogførte værdi ved årets begyndelse og holdes adskilt fra den skattemæssige værdi.',
  'asset.nameRequired': 'Navn på driftsmiddel skal udfyldes.',
  'asset.amountMustBePositive': 'Beløbet skal være større end 0.',
  'asset.planFieldsInvalid': 'Udfyld en gyldig ibrugtagningsdato, brugstid og restværdi.',
  'asset.assessImpairmentRequired': 'Vurder tegn på værdiforringelse for {year}.',
  'asset.impairmentAmountRequired': 'Angiv nedskrivningsbeløbet.',
  'asset.draftContentRequired': 'Tilføj navn, linje eller vedhæftet fil, før du gemmer kladden.',
  'asset.updated': 'Aktiv opdateret',
  'asset.registeredDepreciating': 'Aktiv registreret - afskrives ved årsafslutning',
  'asset.saveFailed': 'Kunne ikke gemme aktivet.',
  'asset.attachmentAdded': 'Vedhæftet fil tilføjet.',
  'asset.savingDots': 'Gemmer...',
  'asset.registerAssetBtn': 'Registrér aktiv',
  'asset.bookDepreciationPanelTitle': 'Regnskabsmæssig afskrivningsplan',
  'asset.bookDepreciationPanelDesc': 'Planen styrer den bogførte værdi. Saldogruppen nedenfor bruges kun til skat.',
  'asset.usefulLifeYearsFieldLabel': 'Brugstid (år)',
  'asset.noImpairmentIndicatorsOption': 'Ingen indikatorer på værdiforringelse',
  'asset.impairmentToBeRecordedOption': 'Nedskrivning skal registreres',
  'asset.documentationPlaceholder': 'Kort begrundelse eller henvisning til dokumentation',
  'asset.supplierPurchaseHelp': 'Knyt aktivet til leverandør og fakturanummer, når købet kommer fra en leverandørfaktura.',
  'asset.noDescriptionFallback': 'Uden beskrivelse',
  'asset.amountModeGross': 'inkl. moms',
  'asset.amountModeNet': 'ekskl. moms',
  'asset.hideVoucher': 'Skjul bilag',
  'asset.showVoucher': 'Vis bilag',
  'asset.reclassAcct6540': 'Inventar',
  'asset.reclassAcct7700': 'Anden omkostning',
  'asset.missingFileLink': 'Mangler fillink',
  'asset.cannotPreviewInBrowser': 'Kan ikke forhåndsvises i browseren.',
  'asset.automaticPostingExplanation': 'Afskrivninger bogføres automatisk for hver afsluttet måned. Plumme indhenter manglende måneder, uden at du behøver at gøre noget.',
  'asset.automaticPostingNeedsReview': 'Automatisk afskrivning kræver opfølgning. Kontrollér aktivets plan, eller kontakt support. Plumme prøver igen, når afvigelsen er rettet.',
  'asset.automaticScopeUnsupported': 'Automatisk afskrivning understøttes indtil videre kun for understøttede norske regnskabsopsætninger.',
  'asset.automaticCorrectionRequired': 'Gennemfør korrektionen af afskrivningsplanen efter tilbageførslen. Derefter fortsætter den automatiske bogføring.',
  'asset.automaticPostingThrough': 'Senest bogførte afskrivning: {date}.',
  'asset.automaticPostingPending': '{amount} resterer til og med {date}. Plumme følger automatisk op på bogføringen.',
  'err.nativeValidation.fixedAssetAcquisitionRegistration.1': 'Vælg én eksisterende anskaffelse, der skal registreres.',
  'err.nativeValidation.fixedAssetAcquisitionRegistration.2': 'Anskaffelsen er allerede registreret som driftsmiddel.',
  'err.nativeValidation.fixedAssetAcquisitionRegistration.3': 'Registreringsdatoen skal svare til den oprindelige anskaffelse.',
});

window.PlummeI18n.register("da", {
  "purchaseFlow.overview": "Købsoversigt",
  "purchaseFlow.search": "Søg køb",
  "purchaseFlow.status": "Status",
  "purchaseFlow.all": "Alle",
  "purchaseFlow.empty": "Ingen køb fundet.",
  "purchaseFlow.creditNumber": "Kreditnotanummer",
  "purchaseFlow.creditNumberRequired": "Angiv leverandørens kreditnotanummer.",
  "purchaseFlow.documents": "Bilag",
  "purchaseFlow.original": "Oprindelig faktura",
  "purchaseFlow.reverse": "Tilbagefør betaling",
  "purchaseFlow.reverseExplanation": "Hele betalingen tilbageføres, også fordelinger til andre fakturaer. Historikken bevares.",
  "purchaseFlow.reason": "Begrundelse",
  "purchaseFlow.more": "Flere handlinger"
});

window.PlummeI18n.register("da", {"purchaseFlow.paymentTotal": "Hele betalingen: {amount}"});

window.PlummeI18n.register("da", {
  "err.supplierPayment.selectionRequired": "Vælg faktura til betalingen.",
  "err.supplierCredit.numberRequired": "Angiv leverandørens kreditnotanummer.",
  "err.supplierCredit.conflict": "Kreditnotaen stemmer ikke med det gemte dokument.",
  "err.supplierCredit.duplicate": "Leverandørens kreditnotanummer er allerede registreret."
});

window.PlummeI18n.register("da", {"purchaseFlow.purchase": "Køb", "purchaseFlow.net": "Netto", "purchaseFlow.vat": "Moms"});

window.PlummeI18n.register("da", {"asset.rename": "Skift navn"});



window.PlummeI18n.register("da", {"asset.cancelDates": "K\u00f8bet fra {purchase} og de tilknyttede posteringer modposteres {date}. Oprindelige bilag og datoer bevares.", "err.asset.cancelDetailsRequired": "Angiv en begrundelse og brug en dato p\u00e5 eller efter k\u00f8bsdatoen.", "err.asset.laterChangesRequired": "Afklar senere \u00e6ndringer af aktivet eller afskrivninger uden entydigt aktiv f\u00f8r salget registreres."});
